import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <h1>HR Management</h1>
            <h3>Hire Employees</h3>
            <p>Total Budget: $6500</p>
        </div>
    );
};

export default Header;